/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Stack, Typography } from '@mui/material';
import {
  hasServicoText,
  parseServicoBlocks,
  shouldFormatServicoDisplay,
} from '../utils/formatServicoDisplay';

const ServicoCell = ({ value }) => {
  if (!hasServicoText(value)) {
    return null;
  }

  if (!shouldFormatServicoDisplay(value)) {
    return (
      <Typography variant="caption" sx={{ whiteSpace: 'pre-wrap', display: 'block' }}>
        {value}
      </Typography>
    );
  }

  const blocks = parseServicoBlocks(value);

  return (
    <Stack spacing={1.25} sx={{ py: 0.25 }}>
      {blocks.map((block, index) => (
        <Box key={index}>
          <Typography
            variant="caption"
            display="block"
            sx={{ fontWeight: 600, lineHeight: 1.45 }}
          >
            {block.header}
          </Typography>
          {block.description ? (
            <Typography
              variant="caption"
              display="block"
              color="text.secondary"
              sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.45, mt: 0.25 }}
            >
              {block.description}
            </Typography>
          ) : null}
        </Box>
      ))}
    </Stack>
  );
};

ServicoCell.propTypes = {
  value: PropTypes.string,
};

ServicoCell.defaultProps = {
  value: '',
};

export default ServicoCell;
